import { IconProps } from '../types';

const ArrowRight = ({ className, color, width, height }: IconProps) => (
  <svg
    className={className}
    width={width ?? 30}
    height={height ?? 30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 23.75L23.75 15L15 6.25M6.25 15L22.5 15L6.25 15Z"
      stroke={color ?? 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowRight;
